module.exports = __webpack_public_path__ + "images/avatars/male/11.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/11.svg
// module id = 5l58
// module chunks = 118